<template>
  <!-- Full viewport background color -->
  <div :class="backgroundClass" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: -1;"></div>
  <div id="app">
    <!-- Navigation Bar -->
    <div class="navbar">
      <router-link to="/turtle-watchintro" class="nav-link" :class="{ 'nav-active': isTurtleWatchActive }">
        Turtle Watch
      </router-link>
      <router-link
        :to="{ name: 'TurtleGuardianintro' }"
        class="nav-link"
        :class="{ 'nav-active': isTurtleGuardianActive }"
      >
        Turtle Guardian
      </router-link>
      <router-link to="/human-waveintro" class="nav-link" :class="{ 'nav-active': isHumanWaveActive }">
        Human Wave
      </router-link>
    </div>
    <!-- Main Content -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    // Determine if Turtle Guardian routes are active
    isTurtleGuardianActive() {
      return this.$route.name === 'TurtleGuardianintro' || this.$route.name === 'TurtleGuardian';
    },
    // Determine if Turtle Watch routes are active
    isTurtleWatchActive() {
      return this.$route.name === 'TurtleWatchintro' || this.$route.name === 'TurtleWatch';
    },
    // Determine if Human Wave routes are active
    isHumanWaveActive() {
      return this.$route.name === 'HumanWaveintro' || this.$route.name === 'HumanWave';
    },
    // Compute the background class based on the current route's meta information
    backgroundClass() {
      return this.$route.meta.backgroundClass || 'default-background'; // Fallback to 'default-background' if no specific class is set
    }
  }
};
</script>

<style>
/* Scrollable main app container */
#app {
  overflow-y: auto;
}
/* Navigation bar styles */
.navbar {
  display: flex;
  width: 510px;
  height: 40px;
  font-size: 16px;
  position: fixed;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  z-index: 1000;
  justify-content: center;
  align-items: center;
  border-radius: 36px;
  gap: 4px;
  padding: 4px;
}
/* Navigation link styles */
.nav-link {
  width: 166px;
  height: 40px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease;
}
.nav-link:not(.nav-active):hover {
  border: 1px solid #007d8e;
  border-radius: 20px;
  color: #007d8e;
}
.nav-active {
  background-color: #007d8e;
  color: #ffffff;
  border-radius: 20px;
}
/* Background styles */
.background-turtle-guardian {
  background: linear-gradient(to top, #226a6d, #69999c);
}
.background-turtle-guardian-intro {
  background-image: url('https://ffern257.github.io/thesis/TTguadian.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.background-human-wave {
  background: linear-gradient(to top, #fed18d, #f1bc7d);
}
.background-human-wave-intro {
  background-image: url('https://ffern257.github.io/thesis/HumanWave.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.background-turtle-watch {
  background: linear-gradient(to top, #226a6d, #69999c);
}
.background-turtle-watch-intro {
  background-image: url('https://ffern257.github.io/thesis/TurtleWatch.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
/* Default background as fallback */
.default-background {
  background-color: #f0f0f0;
}
</style>
